'use strict';

var actionBacklogStates = {
    QUEUED: 'QUEUED',
    PROCESSED: 'PROCESSED',
    DELETED: 'DELETED'
};

module.exports = actionBacklogStates;